import { makeEntity } from "./_base";
export const Account = makeEntity("/accounts");
